import type { FC, ReactNode } from "react";
import { ActivityKeys } from "web_myplann/Api/Activities/ActivityKeys";
import { useIsNoAdvisorQuery } from "web_myplann/Api/Client/useClientQuery";
import { FinanceKeys } from "web_myplann/Api/Finances/financeKeys";
import { TaskKeys } from "web_myplann/Api/Tasks/TaskKeys";
import { DashboardTitleCard } from "web_myplann/Dashboard/Components/DashboardTitleCard";
import { MissingAdvisor } from "web_myplann/Profile/Components/MissingAdvisor";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import { useHideNavbar } from "web_myplann/Shared/Hooks/useHideNavbar";

const pullToRefreshQueryKeys = [
	TaskKeys.lists(),
	ActivityKeys.lists(),
	FinanceKeys.expense(),
	FinanceKeys.income(),
	FinanceKeys.reporting(),
];

type Props = {
	children: ReactNode;
	background?: string;
	showTopGlow?: boolean;
};

export const DashboardShell: FC<Props> = ({
	children,
	background,
	showTopGlow,
}) => {
	const { data: isNoAdvisor } = useIsNoAdvisorQuery();

	useHideNavbar(isNoAdvisor === true);

	if (isNoAdvisor) {
		return (
			<MyPlannLayout disableContentPadding disableTopPadding>
				<MissingAdvisor />
			</MyPlannLayout>
		);
	}

	return (
		<MyPlannLayout
			disableContentPadding
			disableTopPadding
			bgColor={background}
			topGlow={showTopGlow}
		>
			<DashboardTitleCard
				pullToRefreshProps={{ queryKeys: pullToRefreshQueryKeys }}
			>
				{children}
			</DashboardTitleCard>
		</MyPlannLayout>
	);
};
